import { RequiredSKUDetail } from '../../../../../core';

export const requiredSKUDetail = {
    searchText: '',
    sort: false,
    dialogHability: true,
    filter: false,
    checkbox: false,
    expandable: false,
    disabled: false,
    partialField: '',
    columns: [
      {
        title: 'Fecha de despacho',
        name: 'dispatchDate',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: RequiredSKUDetail) => element.dispatchDate
      },
      {
        title: 'Inicio ventana horaria',
        name: 'startDateDeliveryWindow',
        type: 'string',
        class: 'center',
        sortServer: true,
        value: (element: RequiredSKUDetail) => element.startDateDeliveryWindow
      },
      {
        title: 'Fin ventana horaria',
        name: 'endDateDeliveryWindow',
        type: 'string',
        class: 'center',
        sortServer: true,
        value: (element: RequiredSKUDetail) => element.endDateDeliveryWindow
      },
      {
        title: 'Tipo de despacho',
        name: 'dispatchType',
        type: 'string',
        class: 'center',
        sortServer: true,
        value: (element: RequiredSKUDetail) => element.dispatchType
      },
      {
        title: 'Modalidad de despacho',
        name: 'deliveryMode',
        type: 'string',
        class: 'center',
        sortServer: true,
        value: (element: RequiredSKUDetail) => element.deliveryMode
      },
      {
        title: 'N° despacho',
        name: 'dispatchNumber',
        type: 'string',
        class: 'left',
        sortServer: true,
        value: (element: RequiredSKUDetail) => element.dispatchNumber
      },
      {
        title: 'Cliente',
        name: 'customerName',
        type: 'string',
        class: 'left',
        sortServer: true,
        value: (element: RequiredSKUDetail) => element.customerName
      },
      {
        title: 'Sku',
        name: 'skuCode',
        type: 'string',
        class: 'center',
        sortServer: true,
        value: (element: RequiredSKUDetail) => element.skuCode
      },
      {
        title: 'Descripci\u00F3n',
        name: 'description',
        type: 'string',
        class: 'left',
        sortServer: true,
        value: (element: RequiredSKUDetail) => element.description
      },
      {
        title: 'Estado de pedido',
        name: 'stateOrderName',
        type: 'string',
        class: 'center',
        sortServer: true,
        value: (element: RequiredSKUDetail) => element.stateOrderName
      },
      {
        title: 'Cantidad',
        name: 'quantity',
        type: 'string',
        class: 'center',
        sortServer: true,
        value: (element: RequiredSKUDetail) => element.quantity
      },
      {
        title: 'Sustitución (SI/NO)',
        name: 'substitution',
        type: 'string',
        class: 'center',
        sortServer: true,
        value: (element: RequiredSKUDetail) => element.substitution
      },
      {
        title: 'Observaci\u00F3n',
        name: 'observation',
        type: 'string',
        class: 'left',
        sortServer: true,
        value: (element: RequiredSKUDetail) => element.observation
      },
      {
        title: 'Área',
        name: 'area',
        type: 'string',
        class: 'left',
        sortServer: true,
        value: (element: RequiredSKUDetail) => element.area
      },
      {
        title: 'Secci\u00F3n',
        name: 'section',
        type: 'string',
        class: 'left',
        sortServer: true,
        value: (element: RequiredSKUDetail) => element.section
      },
      {
        title: 'Línea',
        name: 'productLine',
        type: 'string',
        class: 'left',
        sortServer: true,
        value: (element: RequiredSKUDetail) => element.productLine
      },
      {
        title: 'Familia',
        name: 'productFamily',
        type: 'string',
        class: 'left',
        sortServer: true,
        value: (element: RequiredSKUDetail) => element.productFamily
      },
    ]
  };
